<template>
  <div>
    <DataTable v-for="spec of speccs" :value="spec.rows"  class="page" :autoLayout="true" :key="spec.header">
      <template #header>
        <div class="p-d-flex p-jc-between">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon" style="color: black">
              Specification
            </span>
            <span class="p-inputgroup-addon">
              <i class="pi pi-id-card"></i>
            </span>
            <span class="p-inputgroup-addon" style="color: black">
              {{spec.header}}
            </span>
          </div>
          <div class="p-inputgroup">
            <Button label="Skriv ut specifikation" icon="pi pi-print" @click="printSpec()" />
          </div>
        </div>
      </template>
      <Column field="article" header="Artikel" />
      <Column field="text" header="Text" />
      <Column field="amount" header="Antal" />
      <Column field="veichule" header="Fordon" />
      <Column field="driver" header="Förare" />
      <Column field="start" header="Starttid" />
      <Column field="end" header="Sluttid" />
    </DataTable>
  </div>
</template>

<script>

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'
import pdfMake from 'pdfmake'
import vfsFonts from 'pdfmake/build/vfs_fonts'

import { HagensLogoBase64Mixin } from '@/mixins/HagensLogoBase64Mixin'

pdfMake.vfs = vfsFonts.pdfMake.vfs

export default {
  name: 'InvoiceHydroSpec',
  mixins: [HagensLogoBase64Mixin],
  components: {
    DataTable,
    Column,
    Button
  },
  props: {
    specifications: Array
  },
  computed: {
    speccs () {
      this.$props.specifications.forEach(element => {
        element.rows = this.orderByDriver(this.orderByArticle(element.rows))
      })
      return this.$props.specifications
    }
  },
  mounted () {
  },
  methods: {
    orderByArticle (rows) {
      const articles = [...new Set(rows.map(row => row.article))]
      let newRows = []
      articles.forEach(article => {
        let articleRows = rows.filter(r => r.article === article)
        newRows = [...newRows, ...articleRows]
      })
      return newRows
    },
    orderByDriver (rows) {
      const drivers = [...new Set(rows.map(row => row.driver))]
      let newRows = []
      drivers.forEach(driver => {
        let driverRows = rows.filter(r => r.driver === driver)
        driverRows.push({article: '', text: '', amount: '', veichule: '', start: '', end: ''})
        newRows = [...newRows, ...driverRows]
      })
      return newRows
    },
    formatForPDF (data) {
      let pdfData = []
      for (const d of data) {
        pdfData.push({text: d.header, style: 'bold', margin: [0, 0, 0, 10]})
        pdfData.push({text: ''})
        pdfData.push({
          margin: [0, 0, 0, 20],
          layout: 'noBorders',
          fontSize: 10,
          table: {
            headerRows: 1,
            widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: [
              [{text: 'Artikel', bold: true}, {text: 'Benämning', bold: true}, {text: 'Antal', bold: true}, {text: 'Fordon', bold: true}, {text: 'Förare', bold: true}, {text: 'Starttid', bold: true}, {text: 'Sluttid', bold: true}],
              ...d.rows.map(r => [
                r.article,
                r.text,
                r.amount,
                r.veichule,
                r.driver === undefined ? '' : r.driver,
                r.start,
                r.end
              ])
            ]
          }
        })
        pdfData.push({text: ''})
      }
      return pdfData
    },
    printSpec () {
      const headerMargins = [0, 3, 0, 0]
      const noBorders = [false, false, false, false]
      const topBorders = [false, true, false, false]
      const docDefinition = {
        pageMargins: [40, 130, 40, 70],
        header: {
          fontSize: 10,
          margin: [40, 20, 40, 10],
          columns: [
            {
              width: 150,
              image: this.hagensLogoString
            },
            {
            },
            [
              { text: 'LEVERANS SPEC', bold: true, margin: [0, 0, 0, 5] },
              {
                columns: [
                  [{ text: 'DATUM', bold: true }, { text: this.speccs[0].date }],
                  [{ text: 'Kund nr', bold: true }, { text: this.speccs[0].customer.data.kundnr }]
                ],
                margin: [0, 0, 0, 5]
              },
              { text: this.speccs[0].customer.data.name },
              { text: this.speccs[0].customer.data.postalAddress },
              { text: this.speccs[0].customer.data.postalAddress2 },
              { text: this.speccs[0].customer.data.zipCode + ' ' + this.speccs[0].customer.data.city }
            ]
          ]
        },
        footer: {
          margin: [40, 10, 40, 10],
          fontSize: 8,
          table: {
            headerRows: 1,
            widths: ['*', '*', '*', '*', '*'],
            body: [
              [
                { border: topBorders, margin: headerMargins, text: 'Postadress', bold: true }, { border: topBorders, margin: headerMargins, text: 'Telefon', bold: true }, { border: topBorders, margin: headerMargins, text: 'E-Post', bold: true }, { border: topBorders, margin: headerMargins, text: 'Org nummer', bold: true }, { border: topBorders, margin: headerMargins, text: 'Bankgiro', bold: true }
              ],
              [
                { border: noBorders, text: 'Vetlandavägen 45' }, { border: noBorders, text: '' }, { border: noBorders, text: '' }, { border: noBorders, text: '' }, { border: noBorders, text: '' }],
              [
                { border: noBorders, text: '574 75 KORSBERGA' }, { border: noBorders, text: '0393-20600' }, { border: noBorders, text: 'info@hagens-akeri.com' }, { border: noBorders, text: '5562003810801' }, { border: noBorders, text: '615-2052' }]
            ]
          }
        },
        content: [...this.formatForPDF(this.speccs)]
      }
      pdfMake.createPdf(docDefinition).open()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Invoices/InvoiceHydroSpec.vue